import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Hook personalizado para manejar errores de autenticación
 * Detecta errores 401/403 y redirige automáticamente al login
 */
export const useAuthErrorHandler = () => {
  const navigate = useNavigate();

  const handleAuthError = useCallback((error: any, context: string = 'operación') => {
    if (error?.response?.status === 401 || error?.response?.status === 403) {
      console.warn(`Sesión expirada detectada en ${context}`);
      sessionStorage.setItem('session_expired_message', 'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.');
      
      const isAdmin = window.location.pathname.startsWith('/admin');
      if (isAdmin) {
        navigate('/admin/login');
      } else {
        navigate('/login');
      }
      return true; // Indica que se manejó el error de autenticación
    }
    return false; // No fue error de autenticación
  }, [navigate]);

  return { handleAuthError };
};
